import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';

@Component({
  selector: 'app-navbar-button',
  template: `<button mat-button [routerLink]="routerLink" fill="clear" (click)="openSettingsMenu($event)">
      <mat-icon [className]="name" [ngClass]="navigationService.GetCurrentRoute() == url ? 'active' : 'inactive'">{{ src }} </mat-icon>
    </button>
    <label [ngClass]="navigationService.GetCurrentRoute() == url ? 'active' : 'inactive'">{{ label }}</label>`,
  styles: [
    `
      mat-button {
        border-radius: 50%;
        height: 56px;
        width: 56px;
        overflow: hidden;
        flex-shrink: 0;
      }

      label {
        margin-top: -18px;
        margin-bottom: 5px;
        text-align: center;
        display: block;
        font-size: 10px;
      }

      .inactive {
        color: var(--ion-color-medium);
      }

      .active {
        color: var(--ion-color-primary);
      }
    `,
  ],
})
export class NavbarButtonComponent {
  @Input() routerLink: any;
  @Input() src: string;
  @Input() url: string;
  @Input() label: string;
  @Input() name: string;
  @Output() openMenu = new EventEmitter<any>();

  openSettingsMenu($event: any) {
    this.openMenu.emit($event);
  }

  constructor(public navigationService: NavigationService) {}
}
